// A country's flag — a small picture from our own server (`public/flags`, from the MIT-licensed
// flag-icons set). ⚠️ Pictures, not emoji: Windows shows flag emoji as two letters in a box.
import React from 'react';
import { flagSrc } from '../../lib/securityWords';

export default function Flag({ country, withName = true }) {
  if (!country || !country.code) return null;
  const src = flagSrc(country.code);
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      {src && (
        <img
          src={src}
          alt=""
          title={country.name}
          className="w-[18px] h-[13.5px] rounded-[2px] shadow-[0_0_0_1px_rgba(0,0,0,0.08)] object-cover"
          loading="lazy"
        />
      )}
      {withName && <span>{country.name}</span>}
    </span>
  );
}
